export enum UserRole {
    SUPER_ADMIN = 'Super Admin',
    ADMIN = 'Admin',
    STAFF = 'Staff',
}